import { CreateSupportDocumentationRequest, CreateSupportDocumentationResponse, ReadAllSupportDocumentationResponse } from "@/backend/express/controllers/supportDocumentationController";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class SupportDocumentationController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async readAllSupportDocumentation(): Promise<ReadAllSupportDocumentationResponse> {
    return this.client.read('/api/support-documentation');
  }

  public async createSupportDocumentation(req: CreateSupportDocumentationRequest): Promise<CreateSupportDocumentationResponse> {
    return this.client.create('/api/support-documentation', req);
  }

  public async deleteSupportDocumentation(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/support-documentation/${id}`);
  }
}

